<template>
    <div class="autocomplete" @click="autocompleteClose()">
        <GmapAutocomplete @click.stop placeholder="Regione, Provincia o Comune" id="address" name="address" class="fieldauto" :options="autoCompleteOption" :value="description" @place_changed="setPlace"></GmapAutocomplete>
    </div>
</template>

<script>
    import { loadGmapApi } from 'vue2-google-maps';
    export default {
        props: ['data'],
        name: 'Autocomplete',
        methods: {
            setPlace(position) {
                let pos = position.geometry.location;

                if (this.isFunction(pos.lat)) {
                    var lat = pos.lat();
                    var lng = pos.lng();
                } else {
                    var lat = pos.lat;
                    var lng = pos.lng;
                }

                this.$emit('centerMap', {
                    lat: lat,
                    lng: lng
                });

                // Chiudo l'autocomplete
                this.autocompleteClose();

            },
            autocompleteClose() {
                this.$emit('closeAutocomplete');
            },
            isFunction(functionToCheck) {
                return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
            }
        },
        beforeMount() {
            // Controllo di non aver già caricato la mappa
            if(! this.$root.mapLoaded){
                // Carico lo script di gmaps
                loadGmapApi({
                    key: this.$root.host ? this.$root.host.google_maps_key : null,
                    libraries: 'places,drawing',
                });
                // Imposto la mappa come caricata
                this.$root.mapLoaded = true;
            }
        },
        data() {
            return {
                description: null,
                autoCompleteOption: {
                    // types: ['(cities)'],
                    fields: ['name', 'geometry.location', 'place_id', 'formatted_address'],
                    componentRestrictions: {
                        country: "it"
                    }
                }
            }
        }
    }
</script>

<style>
    .autocomplete {
        z-index: 10000;
        position: absolute;
        top: 0;
        height: 100vh;
        width: 100%;
        background-color: #0000007c;

    }

    .fieldauto {
        width: 80%;
        height: 70px;
        font-size: 1.5em;
        display: flex;
        margin-top: 36vh;
        margin-left: auto;
        margin-right: auto;
        border-radius: 10px;
        border: 1px solid #666666;
        padding-left: 1em;
    }

    .pac-container {
        z-index: 10000;
        border-radius: 12px;
    }

    .pac-item {
        font-size: 1.2em;
        height: 2.5em;
        line-height: 2.5em;
    }

    .pac-matched {
        font-weight: 600;
    }

    .pac-item-query {
        font-size: 1.2em;
    }

    .pac-icon {
        margin-top: 0.75em;
    }
</style>